// Copyright (c) 2026, Cyber Cube and contributors
// For license information, please see license.txt
//
// One call wrapper, two shells.
//
// On the desk `frappe.call` exists and is used. On the **portal** (M9.9c's
// `/inspect*` routes) it does not: `base.html` loops `web_include_js`, and
// `frappe.call` is defined in `frappe/request.js`, which only `desk.bundle.js`
// imports. `frappe-web.bundle.js` gives the portal jQuery, moment and
// `window.Sortable` but not the desk's request layer.
//
// So this module is the single call site for both, shipped in M9.9a rather than
// M9.9c because the desk pages need it first and a second copy written later
// would be CONVENTIONS #24's drift with nothing comparing the two.
//
// The `fetch` arm posts to `/api/method/<dotted>` with `X-Frappe-CSRF-Token`
// from `frappe.csrf_token`, which the portal's boot does publish. It is a POST
// in both arms — a GET to a whitelisted method bypasses CSRF validation
// entirely (ARCH §10.22), and while every endpoint this module calls is
// read-only, the habit is what matters.

frappe.provide("qhse.facility");

function message(response) {
	// frappe's own error shape: `_server_messages` is a JSON array of JSON
	// strings. Rendered as TEXT by the caller, never as markup.
	try {
		const raw = JSON.parse(response._server_messages || "[]");
		const first = raw.length ? JSON.parse(raw[0]) : null;
		if (first && first.message) return first.message;
	} catch (e) {
		/* fall through to the generic message */
	}
	return (response && response.exc_type) || __("The request could not be completed.");
}

qhse.facility.net = {
	/** Call a whitelisted method, resolving with `message`.
	 *
	 * Rejects with an `Error` whose `.message` is the server's own, so a caller
	 * can put it on screen with `.text()` instead of showing "undefined".
	 */
	call(method, args) {
		if (window.frappe && frappe.call) {
			return new Promise((resolve, reject) => {
				frappe.call({
					method,
					args: args || {},
					callback: (r) => resolve(r ? r.message : undefined),
					error: (r) => reject(new Error(message((r && r.responseJSON) || {}))),
				});
			});
		}
		return this._fetch(method, args);
	},

	_fetch(method, args) {
		const headers = { "Content-Type": "application/json" };
		const token = window.frappe && frappe.csrf_token;
		if (token) headers["X-Frappe-CSRF-Token"] = token;

		return fetch(`/api/method/${method}`, {
			method: "POST",
			headers,
			credentials: "same-origin",
			body: JSON.stringify(args || {}),
		})
			.then((response) =>
				response.json().then((body) => {
					if (!response.ok) throw new Error(message(body));
					return body.message;
				})
			);
	},
};
